import Formatters from '@/Formatters';

declare module '@vue/runtime-core' {
  interface ComponentCustomProperties {
    $format: Formatters;
  }
}

export default {
  install: (app) => {
    const format = new Formatters();
    app.config.globalProperties.$format = format;
    Formatters.$format = format;
  }
};
